import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { FormEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { EMAIL_REGEX_STRING } from '../../constants';
import { submitEmailForPasswordReset } from '../../store/actions/auth';
import Button from '../FormComponents/Button';
import TextField from '../FormComponents/TextField';
import ToastMessage from '../ToastMessage/ToastMessage';

function ResetPasswordEmail() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [toast, setToast] = useState('');
  const [emailValid, setEmailValid] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submitFunc = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);
    dispatch(
      submitEmailForPasswordReset({ email }, (res, message) => {
        setLoading(false);
        if (res === true) {
          navigate('/login', {
            state: {
              message: 'Please check your email for the password reset link. It will expire after one day.',
            },
          });
        } else {
          setToast(message || 'Failed to submit email.');
        }
      }),
    );
  };

  const handleEmailChange = e => {
    setEmailValid(!!e.target.validity.valid);
    setEmail(e.target.value);
  };

  return (
    <Box>
      <Box
        component='form'
        sx={{
          '& > :not(style)': { mt: 1.5, mb: 1.5, width: '100%' },
        }}
        onSubmit={submitFunc}
      >
        <TextField
          label='Email'
          value={email}
          onChange={handleEmailChange}
          error={!emailValid}
          inputProps={{ pattern: EMAIL_REGEX_STRING }}
          helperText={!emailValid ? 'Please input a valid email' : ''}
          required
        />

        <Button text='Submit' style={{ marginTop: '20px' }} loading={loading} />
        <Typography display='flex' justifyContent='flex-end'>
          <Link to='/login'>Login</Link>
        </Typography>
      </Box>
      <ToastMessage toast={toast} close={() => setToast('')} />
    </Box>
  );
}

export default ResetPasswordEmail;
